export default "__VITE_ASSET__CLjxt4Fc__"